export enum WebSocketChatEvents {
  EXCEPTION = 'exception',
  CONNECT_BRAND_NOTIFICATIONS = 'connect-brand-notifications',
  CONNECT_STORE_NOTIFICATIONS = 'connect-store-notifications',
  RECEIVE_NOTIFICATION = 'receive-notification',
  SEND_MESSAGE = 'send-message',
  BROADCAST_MESSAGE = 'broadcast-message',
  JOIN_CHAT = 'join-chat',
  DISCONNECT_FROM_CHAT = 'disconnect-from-chat',
  USER_REMOVED_FROM_CHAT = 'user-removed-from-chat',
  ERROR_IN_MESSAGE = 'error-in-message',
  RECEIVE_TEMPORARY_MESSAGE = 'receive-temporary-message',
  RECEIVE_MANY_TEMPORARY_MESSAGES = 'receive-many-temporary-messages',
  NEW_CHAT_CREATED = 'new-chat-created',
  SUCCESS_SENDING_MESSAGE = 'success-sending-message',
}
